module.exports = __webpack_public_path__ + "static/media/CACAO_06.94ade970.png";